module.exports = __webpack_public_path__ + "../resources/images/sad-4a3420dec433005d40306a6f9dc234c8.svg";